import { Spacer } from '@porsche-code/kado-ui';
import { PHeading, PLink } from '@porsche-design-system/components-react';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { NAMESPACES } from '@/config/i18n';
import { useExchangeRatesAdminListQuery } from '@/graphql';

import { ExchangeRateErrorNotification, ExchangeRateList } from './-components';

export const Route = createFileRoute('/admin/exchange-rates/_auth/')({
  component: ExchangeRatesAdmin,
});

function ExchangeRatesAdmin() {
  const { t } = useTranslation(NAMESPACES);
  const [error, setError] = useState<unknown>();
  const query = useExchangeRatesAdminListQuery();

  return (
    <>
      <PHeading aria-level={1} tag="h1" size="lg">
        {t('exchangeRates.title')}
      </PHeading>
      <Spacer mb="md" />
      {error && (
        <>
          <ExchangeRateErrorNotification
            error={error}
            onDismiss={() => setError(undefined)}
          />
          <Spacer mb="md" />
        </>
      )}
      {query.isError && (
        <>
          <ExchangeRateErrorNotification
            error={query.error}
            onDismiss={() => query.refetch()}
          />
          <Spacer mb="md" />
        </>
      )}
      <ExchangeRateList
        data={query.data?.exchangeRates ?? []}
        isPending={query.isPending}
        onError={setError}
      />
      <Spacer mb="md" />
      <PLink icon="add">
        <Link to="/admin/exchange-rates/new">{t('exchangeRates.new')}</Link>
      </PLink>
    </>
  );
}
